import { useEffect, useState } from "react";
import { Slide, Box, HStack, VStack, Text, Button, IconButton, Icon } from "@chakra-ui/react";
import { FaSyncAlt, FaTimes } from "react-icons/fa";
import { iniciarDetectorDeVersao, aplicarAtualizacaoAgora } from "../../utils/atualizacaoAutomatica";

const ACCENT = "#F68633";

/**
 * Banner discreto de "nova versão disponível".
 *
 * Aparece quando um deploy novo é detectado (via utils/atualizacaoAutomatica).
 * O usuário pode atualizar na hora pelo botão; se ignorar, o próprio detector
 * aplica sozinho num momento seguro (aba em segundo plano ou ociosidade longa,
 * nunca por cima de uma digitação/modal).
 */
const AtualizacaoDisponivel = () => {
    const [visivel, setVisivel] = useState(false);

    useEffect(() => {
        iniciarDetectorDeVersao(() => setVisivel(true));
    }, []);

    return (
        <Slide direction="bottom" in={visivel} style={{ zIndex: 1500 }} unmountOnExit>
            <Box display="flex" justifyContent="center" px={4} pb={{ base: 4, md: 6 }} pointerEvents="none">
                <HStack
                    pointerEvents="auto"
                    spacing={4}
                    bg="white"
                    borderWidth="1px"
                    borderColor="gray.200"
                    borderTopWidth="4px"
                    borderTopColor={ACCENT}
                    boxShadow="0 10px 30px rgba(0,0,0,0.18)"
                    borderRadius="xl"
                    px={{ base: 4, md: 5 }}
                    py={3}
                    w={{ base: "100%", md: "auto" }}
                    maxW="560px"
                    align="center"
                >
                    <Box
                        flexShrink={0}
                        w="38px"
                        h="38px"
                        borderRadius="full"
                        bg="orange.50"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Icon as={FaSyncAlt} color={ACCENT} boxSize="16px" />
                    </Box>

                    <VStack align="start" spacing={0} flex={1} minW={0}>
                        <Text fontWeight="bold" fontSize="sm" color="gray.800">
                            Nova versão disponível
                        </Text>
                        <Text fontSize="xs" color="gray.500" noOfLines={2}>
                            Atualize para carregar as últimas melhorias e correções do sistema.
                        </Text>
                    </VStack>

                    <Button
                        flexShrink={0}
                        size="sm"
                        color="white"
                        bg={ACCENT}
                        _hover={{ bg: "#E4762A" }}
                        _active={{ bg: "#D46B25" }}
                        leftIcon={<FaSyncAlt />}
                        onClick={aplicarAtualizacaoAgora}
                    >
                        Atualizar agora
                    </Button>

                    <IconButton
                        flexShrink={0}
                        aria-label="Depois"
                        title="Depois"
                        icon={<FaTimes />}
                        size="sm"
                        variant="ghost"
                        colorScheme="gray"
                        onClick={() => setVisivel(false)}
                    />
                </HStack>
            </Box>
        </Slide>
    );
};

export default AtualizacaoDisponivel;
